import { authProviders } from './auth/auth.config';
import { httpInterceptorProviders } from './interceptor';
import { EnvironmentProviders, Provider } from '@angular/core';

export const coreProviders: Array<Provider | EnvironmentProviders> = [...authProviders, httpInterceptorProviders];
